module.exports = __webpack_public_path__ + "static/media/contrato.1835099a.svg";